import {NomMois} from 'public/fonctions_evenements.js';
import {NomJour} from 'public/fonctions_evenements.js';
import {session} from 'wix-storage';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

// Variables globales
let _dateActuelle = new Date();
_dateActuelle.setHours(0, 0, 0, 0);


$w.onReady(function () {
	$w('#dataAlerteTempete').onReady(function () {
		// Aller chercher l'information pour savoir si le service est en fonction
		let etatService = $w('#dataAlerteTempete').getCurrentItem();

		// Pop-up alerte tempête si le service est partiellement en fonction ou pas en fonction
		if(etatService.servicePartiellementEnFonction || etatService.servicePasEnFonction) {
			setTimeout(function() { 
				if(!session.getItem("popUpAlerteTempete")) {
					wixWindow.openLightbox("alerteTempete");
					session.setItem("popUpAlerteTempete", "DejaVu");
				}
			}, 5000);
		}
		// Sinon, pop-up infolettres (ne pas montrer 2 pop-ups en même temps)
		else {
			setTimeout(function() { 
				if(!session.getItem("popUpInfolettresAccueil")) {
					// Affichage différent pour mobile et ordinateur
					if(wixWindow.formFactor === "Mobile")
						wixWindow.openLightbox("infolettresAccueil");
					else
						$w('#popUpInfolettres').show();

					session.setItem("popUpInfolettresAccueil", "DejaVu");
				}
			}, 5000);
		}
	});

	// ÉVÉNEMENTS
	// Afficher le chargement
	$w('#repeaterEvenements').hide();
	$w('#chargementEvenements').show();

	$w("#repeaterEvenements").onItemReady( ($item, itemData, index) => {
		if(itemData.date !== undefined) {
			let dateJour = itemData.date.getDate();

			// Affichage des événements
			$item("#lblDateJour").text = dateJour.toString(); // Date du jour
			$item("#lblMois").text = NomMois(itemData.date.getMonth(), false); // Mois
			$item("#lblLongueDate").text = NomJour(itemData.date.getDay(), true) + " le " + dateJour + " "
				 + NomMois(itemData.date.getMonth(), false) + " " + itemData.date.getFullYear(); // Date complète
			$item("#lblTitre").text = itemData.title; // Nom de l'événement

			// Bouton « En savoir plus »
			// Ordre du jour
			if (itemData.pdfOrdreDuJour !== undefined && itemData.pdfOrdreDuJour !== "" && itemData.pdfOrdreDuJour !== null)
				$item('#btnEnSavoirPlus').link = itemData.pdfOrdreDuJour;
			// Document PDF pour événement
			else if (itemData.documentPdf !== undefined && itemData.documentPdf !== "" && itemData.documentPdf !== null)
				$item('#btnEnSavoirPlus').link = itemData.documentPdf;
			// Lien pour événement
			else if (itemData.lien !== undefined && itemData.lien !== "" && itemData.lien !== null)
				$item('#btnEnSavoirPlus').link = itemData.lien;
			else 
				$item('#btnEnSavoirPlus').disable();
		}

		// Couleur de l'événement (couleur du carré)
		if(itemData.couleur !== undefined)
			$item('#boxDateBg').style.backgroundColor = itemData.couleur.valeurHexadecimale;

		// Cacher le chargement
		$w('#repeaterEvenements').show();
		$w('#chargementEvenements').hide();
	});

	// Aller chercher les événements à venir dans la base de données
	wixData.query("Evenements").ge("date", _dateActuelle).include("couleur").limit(1000).find().then((evenements) => {
		let evenementsItems = evenements.items;

		// Aller chercher dans la base de donnée les séances à venir du Conseil
		wixData.query("Proces-verbaux-conseil").ge("date", _dateActuelle).limit(1000).find().then((seancesConseil) => {
			let seancesConseilItems = seancesConseil.items;

			// Aller chercher dans la base de donnée les séances à venir du Comité administratif 
			wixData.query("Proces-verbaux-comite-administratif").ge("date", _dateActuelle).limit(1000).find().then((seancesComiteAdmin) => {
				// Combiner les événements et les ordres du jour en une seule liste
				let evenementsEtODJ = evenementsItems.concat(seancesConseilItems);
				evenementsEtODJ = evenementsEtODJ.concat(seancesComiteAdmin.items);

				// Classer la liste par dates
				evenementsEtODJ.sort((a, b) => a.date - b.date);

				// Garder seulement les 4 premiers événements
				evenementsEtODJ = evenementsEtODJ.slice(0, 4);

				// S'il n'y a aucun événement à afficher
				if (evenementsEtODJ.length === 0) {
					// Cacher le chargement
					$w('#txtAucunEvenement').show();
					$w('#chargementEvenements').hide();
				}
				
				// Afficher les événements
				$w("#repeaterEvenements").data = evenementsEtODJ;
			});
		});
    });

	// AVIS PUBLICS
	$w('#dataAvisPublics').onReady(function () {
		UpdateBtnsAvis();
	});

	// ACTUALITÉS
	$w("#repeaterActualites").onItemReady( ($item, itemData, index) => {
		$item("#imgNouvelle").fitMode = "fit";
	});
});


export function btnMenuLaMRC_click(event) {
	wixLocation.to("/menu?menu=LaMRC"); 
}

export function btnMenuGestionTerritoire_click(event) {
	wixLocation.to("/menu?menu=GestionTerritoire");
}

export function btnMenuServices_click(event) {
	wixLocation.to("/menu?menu=Services");
}

export function btnMenuFinancement_click(event) {
	wixLocation.to("/menu?menu=Financement");
}

// Permet de passer à la prochaine page d'avis publics
export function btnAvisNext_click(event) {
	$w('#repeaterAvisPublics').hide();
	$w('#chargement').show();

	$w('#dataAvisPublics').nextPage().then(function () {
		UpdateBtnsAvis();
		$w('#chargement').hide();
		$w('#repeaterAvisPublics').show();
	});
}

// Permet de revenir à la précédente page d'avis publics
export function btnAvisPrevious_click(event) {
	$w('#repeaterAvisPublics').hide();
	$w('#chargement').show();

	$w('#dataAvisPublics').previousPage().then(function () {
		UpdateBtnsAvis();
		$w('#chargement').hide();
		$w('#repeaterAvisPublics').show();
	});
}

/* Permet d'activer ou de désactiver les boutons de navigation 
   des avis publics en fonction du nombre de pages */
function UpdateBtnsAvis() {
	// Bouton page précédente
	if($w('#dataAvisPublics').hasPreviousPage())
		$w('#btnAvisPrevious').enable();
	else 
		$w('#btnAvisPrevious').disable();

	// Bouton page suivante
	if($w('#dataAvisPublics').hasNextPage())
		$w('#btnAvisNext').enable();
	else 
		$w('#btnAvisNext').disable();
}

/* Permet de fermer le pop-up des infolettres */
export function btnFermerPopUp_click(event) {
	$w('#popUpInfolettres').hide();
}

export function bannierePrixDistinctionFamille_click(event) {
	wixLocation.to("/prix-distinction-famille");
}